import axios from 'axios';

const state = {
  prompt: '',
  skillCard: {
    step: '',
    step_name: '',
    skill_map: '',
    actor_race: '',
    actor_gender: '',
    actor_age: '',
    uniform_type: '',
    uniform_color: '',
    patient_age: '',
    patient_condition: '',
    patient_position: '',
    patient_race: '',
    patient_gender: '',
    environment_setting: '',
    room_type: '',
    time_of_day: '',
    scene_mood: '',
    anchorElements: [],
  },
  requirePatient: '',
  skillCardImage: '',
  filters: {},
};

const getters = {
  getAiSkillPrompt: state => state.prompt,
  getSkillCard: state => state.skillCard,
  getStdSkillCardImage: state => state.skillCardImage,
  getSkillCardFilters: state => state.filters,
  getRequirePatient: state => state.requirePatient,
};

const mutations = {
  setAiSkillPrompt: (state, resp) => {
    state.prompt = resp.prompt;
  },
  setSkillCard: (state, skillCard) => {
    state.skillCard = skillCard;
  },
  setSkillCardImage: (state, image) => {
    state.setSkillCardImage = image;
  },
  setSkillCardFilters: (state, filters) => {
    state.filters = { ...state.filters, ...filters };
  },
  setRequirePatient: (state, isRequired) => {
    state.requirePatient = isRequired;
  },
};

const actions = {
  async getAllSkillMaps(_obj, params) {
    const res = await axios.get(`api/skills/ai/`, { params });
    return res.data;
  },

  async getSkillMap(_obj, id) {
    const res = await axios.get(`api/skills/ai/${id}/`);
    return res.data;
  },

  async createSkillMap(_obj, data) {
    return axios.post(`api/skills/ai/`, data);
  },

  async updateSkillMap(_obj, { id, data }) {
    return axios.patch(`api/skills/ai/${id}/`, data);
  },
  async updateSkillMapActiveStatus(_obj, { id, data }) {
    return axios.patch(`api/skills/ai/${id}/update-is-active/`, data);
  },

  async deleteSkillMap(_obj, id) {
    return axios.delete(`api/skills/ai/${id}/`);
  },
  async getSchoolSkillMaps(_obj, params) {
    const res = await axios.get(`api/skills/skill-ai-card/`, { params });
    return res.data;
  },
  async getAllSkillMapCards(_obj, params) {
    const res = await axios.get(`api/skills/skill-ai-card/`, { params });
    return res.data;
  },
  async getSkillMapSteps(_obj, params) {
    const res = await axios.get(`api/skills/ai/skillmap-steps/`, { params });
    return res.data;
  },
  async getSkillCardImage(_obj, data) {
    const res = await axios.post(`api/skills/skill-ai-card/generate-ai-skill/`, data);
    return res.data;
  },
  async getSkillCardPrompt({ commit }, data) {
    const res = await axios.post(`api/skills/skill-ai-card/get-skillmap-prompt/`, data);
    commit('setAiSkillPrompt', { prompt: res.data.data.prompt });

    return res.data;
  },
  async setSkillCardValues({ commit }, data) {
    commit('setSkillCard', data);
  },
  async updateSkillCardFilters({ commit }, { filters }) {
    commit('setSkillCardFilters', filters);
  },
  async updateRequirePatient({ commit }, requirePatient) {
    commit('setRequirePatient', requirePatient);
  },
  async getSkillStepAnchors(_obj, params) {
    const res = await axios.get(`api/skills/ai/skillstep-anchors/`, { params });
    return res.data;
  },
  async getSkillsetList(_obj, params) {
    const res = await axios.get(`api/skills/ai/skillset-list/`, { params });
    return res.data;
  },
  async getSkillsetCards(_obj, params) {
    const res = await axios.get(`api/skills/skill-ai-card/skillset-cards/`, { params });
    return res.data;
  },
  async getMySkillCards(_obj, params) {
    const res = await axios.get(`api/skills/skill-ai-card/my-skillcards/`, { params });
    return res.data;
  },
  async getOtherStdSkillCards(_obj, params) {
    const res = await axios.get(`api/skills/skill-ai-card/other-std-skillcards/`, { params });
    return res.data;
  },
  async updateSkillCardStatus(_obj, data) {
    const res = await axios.patch(`api/skills/skill-ai-card/update-status/`, data);
    return res.data;
  },
  async getStdSkillCards(_obj, params) {
    const res = await axios.get(`api/skills/skill-ai-card/`, { params });
    return res.data;
  },
};

export const aiSkills = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
